export default __webpack_public_path__ + "static/media/cutWifi.34435be4.png";